module.exports = __webpack_public_path__ + "static/irishConcertoThirdMovement-cf44a8df8d3a5a365aa554e4a16405b3.mp3";